import { jsx as d } from "react/jsx-runtime";
import { useController as k } from "react-hook-form";
import x from "../checkbox-group/checkbox-group.js";
import { useTranslation as b } from "react-i18next";
import { getErrorMessage as y } from "./hook-form-helper.js";
import { useEffect as E } from "react";
import { isArrayWithItems as G } from "../../../helpers/array-helper.js";
import "dayjs";
const S = ({
  rules: n,
  control: s,
  name: i,
  label: l,
  helperText: p,
  checkboxes: c,
  isDisabled: m,
  defaultValue: t
}) => {
  const { t: f } = b(), { field: a, fieldState: g } = k({
    name: i,
    control: s,
    defaultValue: t,
    disabled: m,
    rules: n,
    shouldUnregister: !0
  });
  E(() => {
    t && a.onChange(t);
  }, []);
  const { error: u } = g, { value: o } = a, h = (r) => {
    let e = G(o) ? [...o] : [];
    r.target.checked && !e.includes(r.target.name) ? e.push(r.target.name) : !r.target.checked && e.includes(r.target.name) && (e = e.filter((C) => C !== r.target.name)), a.onChange(e);
  };
  return /* @__PURE__ */ d(
    x,
    {
      checkboxes: c.map((r) => ({
        name: r.name,
        isChecked: o && o.includes(r.name),
        label: r.label,
        value: r.value
      })),
      onChangeNative: h,
      helperText: p,
      errorText: y(f, u),
      label: l,
      isDisabled: m
    }
  );
};
export {
  S as HookFormCheckboxGroup
};
